import { useEffect, useRef } from 'react';

interface UseKeyboardShortcutOptions {
	onToggle: () => void;
	enabled?: boolean;
}

const useKeyboardShortcut = ( { onToggle, enabled = true }: UseKeyboardShortcutOptions ) => {
	const onToggleRef = useRef( onToggle );

	useEffect( () => {
		onToggleRef.current = onToggle;
	}, [ onToggle ] );

	useEffect( () => {
		if ( ! enabled ) {
			return undefined;
		}

		const handleKeyDown = ( event: KeyboardEvent ) => {
			// Check for Cmd+K (Mac) or Ctrl+K (Windows/Linux)
			const isModifierPressed = event.metaKey || event.ctrlKey;

			if ( isModifierPressed && event.key.toLowerCase() === 'k' ) {
				event.preventDefault();
				onToggleRef.current();
			}
		};

		document.addEventListener( 'keydown', handleKeyDown );

		return () => {
			document.removeEventListener( 'keydown', handleKeyDown );
		};
	}, [ enabled ] );
};

export default useKeyboardShortcut;
